module.exports = __webpack_public_path__ + "static/img/tzb-icon.06b6650.png";


//////////////////
// WEBPACK FOOTER
// ./static/tzb-icon.png
// module id = ZTRi
// module chunks = 1